<template>
  <!--  新增能耗模型：季节设定-->
  <div>
    <div class="block">
      <div>{{ Data.data.c_name }}</div>
      <el-button type="text" @click="add_list">添加</el-button>
      <div v-for="(item,index) in list" :key="index">
        <div class=" row mb-2">
          <label class="col-sm-4 lh35 text-lr">名称：</label>
          <div class="col-sm-7 ">
            <el-input v-model="item.name" placeholder="请输入内容" @change="dealData"></el-input>
          </div>
        </div>
        <div class=" row mb-2">
          <label class="col-sm-4 lh35 text-lr">占比：</label>
          <div class="col-sm-7 ">
            <el-slider v-model="item.data[0].ratio" @change="get_season_value_group($event,index)"
                       show-input :max="1" :min="0" :step="0.001">
            </el-slider>

          </div>
        </div>
        <div class=" row mb-2">
          <label class="col-sm-4 lh35 text-lr">起始时间：</label>
          <div class="col-sm-7 ">
            <el-date-picker style="width: 250px" @change="dealData"
                            v-model="item.data[0].date"
                            type="daterange" value-format="MM-dd" format="MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>

          </div>
        </div>
        <el-divider></el-divider>
        <el-button type="text" @click="min_list(index)">删除</el-button>


      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: "season_block",
  props: ['Data'],
  data() {
    return {
      list: [],
      date: '',
    }
  },
  created() {

  },
  mounted() {
    var arry = JSON.parse(JSON.stringify(this.Data.data.c_value))
    for (let i in Object.keys(arry)) {
      this.list.push({'name': Object.keys(arry)[i], 'data': []})
    }
    for (let i in Object.values(arry)) {
      console.log(this.list[i].data, Object.values(arry)[i].end_date)
      this.list[i].data.push({
        'date': [Object.values(arry)[i].start_date, Object.values(arry)[i].end_date],
        'ratio': Object.values(arry)[i].ratio,
      })
    }
    console.log(this.list, 'kj')

  },
  methods: {
    dealData() {
      var obj = {}
      for (let i in this.list) {
        obj[this.list[i].name] = {
          'ratio': this.list[i].data[0].ratio,
          'start_date': this.list[i].data[0].date[0],
          'end_date': this.list[i].data[0].date[1],
        }
      }
      this.$get_function(this.Data, obj)
    },
    add_list() {
      this.list.push({'name': '', 'data': [{'ratio': 0, 'date': ''}]})
    },
    min_list(index) {
      this.list.splice(index, 1)
    },
    get_season_value_group(e, index) {
      //循环list列表，定义变量num为list中ratio的总和，并且num小于等于1
      var num = 0
      for (let i in this.list) {
        num += this.list[i].data[0].ratio
      }
      //如果num大于1，那么就把当前的ratio减去num-1，然后把其他的ratio平均分配
      if (num > 1) {
        this.$message({
          message: '占比总和不能大于1',
          type: 'warning'
        })
        this.list[index].data[0].ratio = Number((e - (num - 1)).toFixed(3))
        var len = this.list.length
        for (let i in this.list) {
          if (index !== Number(i)) {
            this.list[i].data[0].ratio = Number((1 - e).toFixed(3) / (len - 1))
          }
        }
      }
      this.dealData()
    },
  }
}
</script>

<style scoped>

</style>